import React from 'react';
import PageHero from '../common/PageHero';
import { useTranslation } from 'react-i18next';

const ContactHero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <PageHero
      eyebrow={t('contactSection.hero.eyebrow')}
      title={t('contactSection.hero.title')}
      description={t('contactSection.hero.description')}
      typedTitle
    />
  );
};

export default ContactHero;
